import { post } from "@readai/common/api";

import type { FeedbackRequest } from "../types/feedbackTypes";

export const sendFeedback = async (request: FeedbackRequest): Promise<void> => {
  return post("/v1/feedback/simple", request, {
    withCreds: true,
  });
};
